import { render, staticRenderFns } from "./NoPermission.vue?vue&type=template&id=3901fcfc"
import script from "./NoPermission.vue?vue&type=script&lang=js"
export * from "./NoPermission.vue?vue&type=script&lang=js"
import style0 from "./NoPermission.vue?vue&type=style&index=0&id=3901fcfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports